import { forwardRef, type Ref, type SVGProps } from "react";
const IconAutofillOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M19 22H4V9h15V7H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h16z"
    />
    <path
      fill="currentColor"
      d="M29 7h-6V5h3V3h-8v2h3v21h-3v2h8v-2h-3v-2h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-1 15h-5V9h5zM10.2 11a1 1 0 0 0-.93.63l-2.8 7a1 1 0 1 0 1.86.74L8.88 18h2.63l.56 1.39A1 1 0 0 0 13 20a1 1 0 0 0 .93-1.37l-2.8-7a1 1 0 0 0-.93-.63m-.52 5 .52-1.31.52 1.31z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAutofillOutlineSVG);
ForwardRef.displayName = "IconAutofillOutline";
export { ForwardRef as IconAutofillOutline };
